<template>
  <v-container grid-list-lg>
    <v-row no-gutters>
      <v-col>
        <router-view></router-view>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ManufacturingCommand",
  data() {
    return {};
  }
};
</script>
